import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import service1 from "../assets/service1.png";
import service2 from "../assets/service2.png";
import service3 from "../assets/service3.png";
import service4 from "../assets/service4.png";
import service5 from "../assets/service5.png";
import service6 from "../assets/service6.png";
import project1 from "../assets/project1.png";
import project2 from "../assets/project2.png";
import project3 from "../assets/project3.png";
import project4 from "../assets/project4.png";
import project5 from "../assets/project5.png";
import project6 from "../assets/project6.png";
import Modal from "./Modal";

const serviceData = [
  { 
    id: 1, 
    title: ["General Construction", "BETIRET APARTMENT"], 
    image: [service1, project1],
    description: "We build homes, offices, and commercial buildings from the ground up managing every phase from start to finish with quality and care."
  },
  { 
    id: 2, 
    title: ["Design & build", "MANSION HOUSE"], 
    image: [service2, project2],
    description: "We provide an all-in-one solution by handling both the design and construction, ensuring a smooth, efficient, and cost-effective process."
  },
  { 
    id: 3, 
    title: ["Renovate & maintenace", "AFRICA UNION OFFICE"], 
    image: [service3, project3],
    description: "We repair, upgrade, and maintain existing buildings to keep them safe, functional, and visually appealing."
  },
  { 
    id: 4, 
    title: ["Civil Engineering", "HAYAT APARTMENT"], 
    image: [service4, project4],
    description: "We take on essential public projects such as, drainage systems and structural foundations that support community growth."
  },
  { 
    id: 5, 
    title: ["Infrastructure Projects", "HAYA-HULET APARTMENT"], 
    image: [service5, project5],
    description: "We develop core infrastructure including water supply systems, sewage networks, and utility installations for long-term reliability."
  },
  { 
    id: 6, 
    title: ["Equipment Rental", "HAYAT APARTMENT"], 
    image: [service6, project6],
    description: "We offer well-maintained construction equipment for rent, helping clients complete their projects efficiently and affordably."
  },
];

const ServicesSection = ({
  title = "Services",
  marginTop = "",
  showAll = false,
  services = serviceData
}) => {
  // Determine which option to use for title and image
  // If title is "Works" (case-insensitive), use index 1, else use index 0
  const isWorks = String(title).toLowerCase() === "works";
  const optionIndex = isWorks ? 1 : 0;

  // Map services to use the correct title and image option
  const mappedServices = services.map(service => ({
    ...service,
    title: Array.isArray(service.title) ? service.title[optionIndex] : service.title,
    image: Array.isArray(service.image) ? service.image[optionIndex] : service.image,
  }));

  const [selectedService, setSelectedService] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => setLoading(false), 1500);
    return () => clearTimeout(timer);
  }, [title, showAll, services]);

  const openModal = (service) => {
    setSelectedService(service);
    setModalOpen(true);
  };

  const closeModal = () => {
    setSelectedService(null);
    setModalOpen(false);
  };

  // Determine how many cards to show
  let visibleServices = mappedServices;
  if (!showAll) {
    visibleServices = mappedServices.slice(0, 3);
  }

  return (
    <section className={`py-16 px-6 lg:px-20 bg-white ${marginTop}`}>
      <div className="max-w-7xl mx-auto text-center lg:text-left">
        {/* Title */}
        {loading ? (
          <Skeleton height={40} width={250} className="mb-10" style={{ marginBottom: 40, borderRadius: 8 }} />
        ) : (
          <h2 className="text-3xl font-extrabold text-[#003A7D] uppercase mb-10">
            Our
            <br />
            {title}
          </h2>
        )}

        {/* Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-10">
          {loading
            ? Array.from({ length: showAll ? mappedServices.length : 3 }).map((_, idx) => (
                <div key={idx} className={`text-center ${!showAll && idx === 2 ? 'hidden lg:block' : ''}`}>
                  <Skeleton className="w-full h-48 mb-2" style={{ borderRadius: 12, height: '192px' }} />
                  <Skeleton height={20} width={120} style={{ margin: '0 auto', borderRadius: 8 }} />
                </div>
              ))
            : visibleServices.map((service, idx) => (
                <div
                  key={service.id}
                  className={`text-center cursor-pointer ${!showAll && idx === 2 ? 'hidden lg:block' : ''}`}
                  onClick={() => openModal(service)}
                >
                  <div className="transition-transform duration-300 ease-in-out hover:scale-105 ">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-[21.5rem] h-64 md:h-[27.5rem] object-cover shadow-sm hover:shadow-xl  mx-auto"
                    />
                    <p className="mt-5 mx-auto md:w-[21.5rem] text-base text-left object-cover font-medium text-black uppercase">{service.title}</p>
                  </div>
                </div>
              ))}
        </div>

        {/* CTA Button */}
        {(!showAll || loading) && (
          <div className="mt-10 text-center">
            {loading ? (
              <Skeleton height={40} width={220} style={{ borderRadius: 20, margin: '0 auto' }} />
            ) : (
              <button
                className="bg-[#003A7D] hover:bg-blue-900 text-white px-6 py-3 text-sm font-semibold"
                onClick={() => navigate("/services")}
              >
                EXPLORE ALL {title.toUpperCase()}
              </button>
            )}
          </div>
        )}
      </div>

      {/* Modal */}
      <Modal isOpen={isModalOpen} onClose={closeModal} service={selectedService} />
    </section>
  );
};

export default ServicesSection;
